import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, DialogActions, DialogContent, Grid } from '@mui/material';
import DropCustom from 'components/dropZone/DropCustom';
import { ModalActionProps } from 'models/AutoModals';


type UploadBatchPdfDialogProps = {
} & ModalActionProps<File[]>

const UploadBatchPdfDialog = ({ onFinish }: UploadBatchPdfDialogProps) => {
    const {t} = useTranslation('cars');
    const [ files, setFiles ] = useState<File[]>([]);

    const submit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        onFinish(files);
    };

    return (
        <Box component="form" onSubmit={submit}>
            <DialogContent>
                <DropCustom
                    title={t('batch_upload_export_certificate_description')}
                    options={{
                        onDropAccepted: files => setFiles(old => [...old, ...files]),
                        accept: {
                            'image/*': ['.jpeg', '.png'],
                            'application/pdf': ['.pdf'],
                        },
                    }}
                />

                {!!files.length && (
                    <Grid container spacing={2} sx={{ '.MuiGrid-item': {overflow: 'hidden', textOverflow: 'ellipsis' }}}>
                        {files.map(f => <Grid item key={f.name} xs={6} sm={4}>{f.name}</Grid>)}
                    </Grid>
                )}
            </DialogContent>

            {!!files.length && (
                <DialogActions>
                    <Button type="submit">{t('upload')}</Button>
                </DialogActions>
            )}
        </Box>
    );
};

export default UploadBatchPdfDialog;
